import { Link } from "react-router-dom";
import { PendingStatus } from "@/components/ui/pending-indicator";
import type { DeskGlanceTopParty } from "@/shared/api/desk";
import { formatGlanceMoney } from "./owner-glance-math";
import { HomeMetricCard } from "./HomeMetricCard";

const COMPACT_N = 3;

function RankList(props: {
  rows: DeskGlanceTopParty[];
  companySlug: string;
  currencyCode: string;
  limit: number;
}) {
  return (
    <ol className="m-0 list-none space-y-2 p-0">
      {props.rows.slice(0, props.limit).map((row, i) => {
        const money =
          formatGlanceMoney(row.balance, props.currencyCode, {
            maxFractionDigits: 0,
            zeroOk: true,
          }) ?? row.balance;
        return (
          <li key={row.partyId}>
            <Link
              to={`/c/${props.companySlug}/contacts/${row.partyId}`}
              className="grid grid-cols-[1.25rem_1fr_auto] items-baseline gap-2 no-underline"
            >
              <span className="text-xs tabular-nums text-[var(--color-muted)]">
                {i + 1}.
              </span>
              <span className="min-w-0 truncate text-sm font-medium text-[var(--color-foreground)]">
                {row.name}
              </span>
              <span className="text-xs tabular-nums text-[var(--color-muted)]">
                {money}
              </span>
            </Link>
          </li>
        );
      })}
    </ol>
  );
}

/** Compact Top to-collect parties → Show more dialog — plan/50. */
export function TopCollectWidget(props: {
  companySlug: string;
  currencyCode: string;
  rows: DeskGlanceTopParty[] | null | undefined;
  loading?: boolean;
  onCustomize?: () => void;
}) {
  const rows = props.rows ?? [];
  if (props.loading && !props.rows) {
    return (
      <HomeMetricCard
        title="Top to collect"
        description="Open SO balance by customer"
        onCustomize={props.onCustomize}
        compact={<PendingStatus>Loading…</PendingStatus>}
        expanded={<PendingStatus>Loading…</PendingStatus>}
      />
    );
  }
  return (
    <HomeMetricCard
      title="Top to collect"
      description="Open SO balance by customer"
      expandedDescription="Highest open receivables. Tap a row for the contact."
      onCustomize={props.onCustomize}
      empty={rows.length === 0}
      emptyMessage="Nothing open to collect."
      compact={
        <RankList
          rows={rows}
          companySlug={props.companySlug}
          currencyCode={props.currencyCode}
          limit={COMPACT_N}
        />
      }
      expanded={
        <RankList
          rows={rows}
          companySlug={props.companySlug}
          currencyCode={props.currencyCode}
          limit={8}
        />
      }
    />
  );
}
